import { BaseEntity, DefaultResponseWithData } from "../system";

export interface IReportsResponse extends DefaultResponseWithData<IReport[]> { }

export interface IReportDateField {
  key: string;
  label: string;
}

export interface IReport extends BaseEntity {
  title: string;
  /**
   * Legacy flag: both dates required, filtered on whichever column the report's SQL hardcoded.
   * Only meaningful while `dateFields` is empty - a report that declares date fields has been
   * converted and ignores this. Removed once every report has been rewritten.
   */
  allowDates: boolean;
  /**
   * JSON array of `{ key, label }` date columns this report can filter on, as stored in Betty.
   * Null or empty means the report has not been converted (or offers no dates at all).
   */
  dateFields: string | null;
  lastRan: string | null;
}

/**
 * Reads the declared date fields off a report.
 *
 * Tolerant in the same direction as the API's ReportDateFilterRules.ParseFields: anything
 * unusable - null, blank, malformed JSON, entries without a key - yields an empty list, which
 * drops the report back to its legacy behaviour rather than breaking the page. Both ends have to
 * agree on what is parseable, or the UI could offer a field the API then rejects.
 */
export function parseReportDateFields(dateFields: string | null | undefined): IReportDateField[] {
  if (!dateFields || !dateFields.trim()) return [];

  try {
    const parsed = JSON.parse(dateFields);
    if (!Array.isArray(parsed)) return [];

    return parsed
      .filter((x) => x && typeof x.key === "string" && x.key.trim())
      .map((x) => ({ key: x.key, label: x.label || x.key }));
  } catch {
    return [];
  }
}
